export default __webpack_public_path__ + "static/media/person-charac02.c671521f.png";